import { render, staticRenderFns } from "./PreviewTable.vue?vue&type=template&id=53b8f1c8&"
import script from "./PreviewTable.vue?vue&type=script&lang=ts&"
export * from "./PreviewTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports